export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -04.26e94796.png";